import React from 'react';
import { Link } from "react-router-dom";
import * as ROUTES from '../routes/routes';

import phleboindia from '../assets/images/phleboindia.svg';



class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <>
                <footer className=" section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="order-lg-2 col">
                                <div className="footermenu">
                                    <h4 className="footer-title">Get to Know Us</h4>
                                    <ul>
                                        <li>
                                            <Link title="Home">Home</Link>
                                        </li>
                                        <li>
                                            <Link title="About Us">About Us</Link>
                                        </li>
                                        <li>
                                            <Link title="Contact Us">Contact Us</Link>
                                        </li>
                                        <li>
                                            <Link  title="Privacy Policy">Privacy Policy</Link>
                                        </li>
                                        <li>
                                            <Link title="Terms of Service">Terms of Service</Link>
                                        </li>
                                        {/* <li className={(this.props.prop.location.pathname == ROUTES.TERMS_OF_SERVICE ) ? "active" : ''}>
                                            <Link to={ROUTES.TERMS_OF_SERVICE} title="Terms of Service">Terms of Service</Link>
                                        </li> */}
                                    </ul>
                                </div>
                            </div>
                            <div className="order-lg-3 col">
                                <div className="footermenu">
                                    <h4 className="footer-title">Connect with Us</h4>
                                    <ul>
                                        <li>
                                            <Link to="https://www.facebook.com" target="_blank" title="Facebook">Facebook</Link>
                                        </li>
                                        <li>
                                            <Link to="https://twitter.com" target="_blank" title="Twitter">Twitter</Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.instagram.com" title="Instagram" target="_blank">Instagram</Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.linkedin.com/" title="LinkedIn" target="_blank">LinkedIn</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="order-lg-4 col">
                                <div className="footermenu">
                                    <h4 className="footer-title">Contact Us</h4>
                                    <ul>
                                        <li>
                                            <Link to="#" onClick={() => window.location = 'https://goo.gl/maps/q3weWNQf9PfP1VyKA'} target="_blank" title="502, Notus IT Park, Sarabhai Campus">502, Notus IT Park,<br/> Sarabhai Campus
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="contact@phleboindia.com" onClick={() => window.location = 'mailto:yourmail@domain.com'}>contact@phleboindia.com</Link>
                                        </li>
                                        <li>
                                           <Link to="#" onClick={() => window.location = 'tel:+91 9898989898'} title="+91 9898989898">+91 9898989898</Link>
                                        </li>
                                        {/* <li className={(this.props.prop.location.pathname == ROUTES.BECOME_A_DRIVER ) ? "active" : ''}>
                                           <Link to={ROUTES.BECOME_A_DRIVER}  title="Become a Driver">Become a Driver</Link>
                                        </li> */}
                                    </ul>
                                </div>
                            </div>
                            <div className="order-lg-1 col col-4">
                                <div className="footer-icon">
                                    <img src={phleboindia} alt="Phlebo India" />
                                </div>
                                <div className="footer-download-btn">
                                    <a href="https://www.apple.com/in/app-store/" target="_blank" title="App Store" className="common-btn"><i className="fab fa-apple"></i> App Store</a>
                                    <a href="https://play.google.com/store" target="_blank" title="Google Play" className="common-btn"><i className="fab fa-google-play"></i> Google Play</a>
                                </div>
                                <p className="copyright">© 2022 PhleboIndia, All rights reserved.</p>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        );
    }
};

export default Footer;